export interface RailTrackFormProfile {
  id?: string
  name: string
  length?: number | null
}

export const defaultValues: RailTrackFormProfile = {
  name: '',
}
